module.exports = __webpack_public_path__ + "static/media/wine-bg.bab08e81.jpg";